import PropTypes from 'prop-types';
import styled from 'styled-components';
import FilesItem from './FilesItem';

const ImagesWrapper = styled.div`
  padding: 0;
  margin-top: 24px;
`;

const FilesList = ({ files, onDelete, onChange, disabled }) => {
  return (
    <>
      {files.length > 0 && (
        <ImagesWrapper>
          {files?.map((src) => (
            <FilesItem
              key={`file-${src?.data?.id}`}
              file={src}
              onDelete={(file) => onDelete(file)}
              onChange={onChange}
              disabled={disabled}
            />
          ))}
        </ImagesWrapper>
      )}
    </>
  );
};

FilesList.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])
  ),
  onDelete: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default FilesList;
